import React from 'react';
import Dropzone from 'react-dropzone';

import { triggerEvent } from '../../services/dom/eventTrigger';

class DropzoneButton extends React.Component {
    constructor() {
        super();

        this.isButtonReferenceInitialised = false;
    }

    _onDropzoneReferenceLoaded() {
        if (this.isButtonReferenceInitialised) return;

        const button = document.getElementById(this.props.id);

        if (button && !button.hasAttribute('tabindex')) {
            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-label', 'Click to open the file chooser');

            button.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    triggerEvent(button, 'click');
                }
            });

            this.isButtonReferenceInitialised = true;
        }
    }

    render() {
        return (
            <Dropzone {...this.props} ref={this._onDropzoneReferenceLoaded.bind(this)}>
                {this.props.children}
            </Dropzone>
        );
    }
}

DropzoneButton.defaultProps = {
    id: 'dropzone-button'
};

export default DropzoneButton;



// WEBPACK FOOTER //
// ./components/DropzoneButton/index.js